import { enableProdMode, importProvidersFrom, inject, provideAppInitializer } from '@angular/core';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { AppConfigService } from './app/core/services/app-config.service';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  providers: [
    importProvidersFrom(AppModule),
    // eslint-disable-next-line @typescript-eslint/no-deprecated
    provideAnimationsAsync(),
    provideAppInitializer(() => inject(AppConfigService).load())
  ]
}).catch((err: unknown) => { console.error(err); });